module.exports = __webpack_public_path__ + "static/media/child.4f9c8232.png";